<template>
  <div class="details">
    <back />
    <div class="con" v-loading="loading">
      <h4>基本信息</h4>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="ruleForm" :disabled="disabled">
        <el-row>
          <el-col :span="8">
            <el-form-item label="优惠券名称" prop="couponName">
              <el-input v-model="ruleForm.couponName" placeholder="请输入优惠券名称"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="couponType">
              <el-select v-model="ruleForm.couponType" placeholder="请选择类型">
                <el-option v-for="(item, index) in options1" :key="index" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="优惠起始日期" prop="startDate">
              <el-date-picker v-model="ruleForm.startDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="总数量" prop="totalCount">
              <el-input v-model.number="ruleForm.totalCount" type="number" placeholder="请输入总数量"></el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.couponType == '1'" label="减免金额" prop="reductionAmount">
              <el-input v-model.number="ruleForm.reductionAmount" type="number" placeholder="请输入减免金额" @input="reductionAmountChange"></el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.couponType == '2'" label="折扣率" prop="discountRate" :rules="ruleForm.couponType == 2 ? discountRate : null">
              <el-input v-model.number="ruleForm.discountRate" type="number" placeholder="请输入折扣率">
                <span slot="suffix">%</span>
              </el-input>
            </el-form-item>
            <el-form-item v-if="ruleForm.couponType == '3'" label="固定金额" prop="fixedAmount">
              <el-input v-model.number="ruleForm.fixedAmount" type="number" placeholder="请输入固定金额"></el-input>
            </el-form-item>
            <el-form-item label="优惠截止日期" prop="endDate">
              <el-date-picker v-model="ruleForm.endDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="订单金额" prop="orderAmount" :rules="ruleForm.couponType == 1 ? orderAmount : null">
              <el-input v-model.number="ruleForm.orderAmount" type="number" placeholder="请输入订单金额"></el-input>
            </el-form-item>
            <el-form-item label="是否启用" prop="couponStatus">
              <el-select v-model="ruleForm.couponStatus" placeholder="请选择是否启用">
                <el-option label="启用" value="1"></el-option>
                <el-option label="停用" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <div class="table_wrap">
        <h4>适用门店</h4>
        <el-button v-if="sign !== '查看'" type="primary" size="mini" @click="addStore">新增门店</el-button>
      </div>
      <div class="g_table">
        <el-table class="" :data="storeList1" style="width: 100%" max-height="540">
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage1 - 1) * pageSize1 }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" prop="storeName" label="门店名称"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" prop="address" label="门店地址"></el-table-column>
          <el-table-column v-if="sign !== '查看'" label="操作" header-align="center" align="center" width="100" fixed="right">
            <template slot-scope="scope">
              <el-button type="danger" size="" plain @click="handleDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination v-if="sign != '新增'" background @size-change="handleSizeChange1" @current-change="handleCurrentChange1" :current-page.sync="currentPage1" :page-size="pageSize1" :page-sizes="pageSizeArr1" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount1"></el-pagination>
      </div>

      <div v-if="sign !== '查看'" class="btn">
        <el-button type="primary" @click="submitForm('ruleForm')">{{ sign }}</el-button>
      </div>
    </div>

    <!-- 未选门店列表 -->
    <el-dialog title="选择门店" :visible.sync="dialogVisible" :before-close="onCancel">
      <div class="s_wrapper">
        <el-input class="s_input" v-model="storeName" placeholder="请输入门店名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
      </div>

      <div class="g_table" v-loading="dialogVisibleLoading">
        <el-table ref="multipleTable" :data="storeList2" style="width: 100%" max-height="540" row-key="storeId" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" :reserve-selection="sign == '新增' ? true : false"></el-table-column>
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage2 - 1) * pageSize2 }}
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" prop="storeName" label="门店名称"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="160" prop="address" label="门店地址"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="100" prop="chargeMan" label="负责人"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="120" prop="contactTel" label="联系电话"></el-table-column>
          <el-table-column show-overflow-tooltip min-width="100" prop="employCount" label="员工人数"></el-table-column>
        </el-table>
        <el-pagination class="pg_input" background @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page.sync="currentPage2" :page-size="pageSize2" :page-sizes="pageSizeArr2" layout="prev, pager, next, jumper, sizes, total" :total="totalItemsCount2"></el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="primary" @click="onConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
function createInitRuleForm() {
  return {
    couponName: "", // 优惠券名称
    couponStatus: "", // 状态：1正常；3停用；9删除
    couponType: "1", // 类型：1满减券；2折扣；3代金券（固定金额）
    reductionAmount: "", // 减免金额（couponType=1，满减券时使用）
    discountRate: "", // 折扣率（couponType=2，折扣券时使用）
    fixedAmount: "", // 固定金额（couponType=3，代金券时使用）
    totalCount: "", // 总数量
    orderAmount: "", // 订单金额
    productType: "1", // 商品类型：1全场通用；2指定商品
    startDate: "", // 优惠券起始日期
    endDate: "", // 优惠券截止日期
    storeIds: [], // 门店列表
  }
}
export default {
  data() {
    return {
      loading: false,
      dialogVisibleLoading: false,
      id: this.$route.query.id || null,
      sign: this.$route.query.sign,
      options1: [
        { value: "1", label: "满减券" },
        { value: "2", label: "折扣" },
        // { value: '3', label: '代金券' },
      ],
      disabled: false,
      ruleForm: createInitRuleForm(),
      checkList: [],
      storeName: "",
      selectedRows: [], // 已勾选门店
      storeList1: [],
      storeList2: [],
      rules: {
        couponName: [{ required: true, message: "请输入优惠券名称", trigger: ["blur", "change"] }],
        totalCount: [{ required: true, message: "请输入总数量", trigger: ["blur", "change"] }],
        couponType: [{ required: true, message: "请选择类型", trigger: ["blur", "change"] }],
        couponStatus: [{ required: true, message: "请选择是否启用", trigger: ["blur", "change"] }],
        productType: [{ required: true, message: "请选择适用商品", trigger: ["blur", "change"] }],
        startDate: [{ required: true, message: "请选择日期", trigger: ["blur", "change"] }],
        endDate: [{ required: true, message: "请选择日期", trigger: ["blur", "change"] }],
        reductionAmount: [
          { required: true, message: "请输入减免金额", trigger: ["blur", "change"] },
          {
            validator: (rule, value, callback) => {
              if (Number(value) < 0) {
                callback(new Error("减免金额不能小于 0"))
              } else if (Number(value) > Number(this.ruleForm.orderAmount)) {
                value = ""
                callback(new Error("减免金额不能大于订单金额"))
              } else {
                callback()
              }
            },
            trigger: ["blur", "change"],
          },
        ],
        fixedAmount: [{ required: true, message: "请输入固定金额", trigger: ["blur", "change"] }],
      },
      orderAmount: [{ required: true, message: "请输入订单金额", trigger: ["blur", "change"] }],
      checkListRules: [{ required: true, message: "请选择该优惠券指定的商品", trigger: ["blur", "change"] }],
      discountRate: [
        { required: true, message: "请输入折扣率", trigger: ["blur", "change"] },
        {
          validator: (rule, value, callback) => {
            if (value < 0 || value > 100) {
              callback(new Error("折扣率不能小于 0 或大于 100 "))
            } else {
              callback()
            }
          },
          trigger: ["blur", "change"],
        },
      ],

      currentPage1: 1, // 当前页码
      pageSize1: 10, // 每页显示的行数
      pageSizeArr1: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount1: 0, // 总记录数（需要从后端获取）

      currentPage2: 1, // 当前页码
      pageSize2: 10, // 每页显示的行数
      pageSizeArr2: [10, 20, 50], // 每页显示的行数(可选)
      totalItemsCount2: 0, // 总记录数（需要从后端获取）

      dialogVisible: false,
    }
  },
  created() {
    this.disabled = this.sign == "查看" ? true : false
    document.title = `${this.sign}优惠券`

    if (this.id) this.getDetail()
  },
  methods: {
    getDetail() {
      this.loading = true
      this.$axios
        .get(`${this.$api.couponSelectInfo}/${this.id}`)
        .then(res => {
          this.ruleForm = res.result
          this.getStoreList1()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.desc)
        })
    },
    // 已选门店列表
    getStoreList1() {
      this.$axios
        .get(this.$api.couponselectCouponStore, {
          params: {
            couponId: this.id,
            page: this.currentPage1,
            pageSize: this.pageSize1,
          },
        })
        .then(res => {
          this.storeList1 = res.result.list
          this.totalItemsCount1 = res.result.totalCount
        })
        .catch(err => {
          this.$message.error(err.desc)
        })
    },
    // 未选门店列表
    getStoreList2() {
      this.dialogVisibleLoading = true
      this.$axios
        .get(this.$api.couponchooseStore, {
          params: {
            storeName: this.storeName,
            couponId: this.id,
            page: this.currentPage2,
            pageSize: this.pageSize2,
          },
        })
        .then(res => {
          this.storeList2 = res.result.list
          this.totalItemsCount2 = res.result.totalCount
          this.dialogVisibleLoading = false
        })
        .catch(err => {
          this.dialogVisibleLoading = false
          this.$message.error(err.desc)
        })
    },
    onSearch() {
      this.storeList2 = []
      this.currentPage2 = 1
      this.getStoreList2()
    },
    // 新增门店
    addStore() {
      this.dialogVisible = true
      if (this.sign == "修改") {
        this.storeList2 = []
        this.selectedRows = []
      }
      this.getStoreList2()
    },
    // 删除门店
    handleDel(e) {
      this.$confirm("即将删除该门店, 是否继续?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          if (this.sign == "新增") {
            this.storeList1 = this.storeList1.filter(item => item.storeId !== e.storeId)
            this.$message.success("删除成功")
          } else {
            this.$axios
              .post(this.$api.coupondeleteStore, {
                couponId: this.id,
                storeId: e.storeId,
              })
              .then(res => {
                this.$message.success("删除成功")
                this.getStoreList1()
                this.selectedRows = this.selectedRows.filter(item => item.storeId !== e.storeId)
              })
              .catch(err => {
                this.$message.error(err.desc)
              })
          }
        })
        .catch(() => {})
    },
    // 切换每页显示的条数
    handleSizeChange1(e) {
      this.storeList1 = []
      this.pageSize1 = e
      this.getStoreList1()
    },
    // 换页
    handleCurrentChange1(e) {
      this.storeList1 = []
      this.currentPage1 = e
      this.getStoreList1()
    },
    // 切换每页显示的条数
    handleSizeChange2(e) {
      this.storeList2 = []
      this.pageSize2 = e
      this.getStoreList2()
    },
    // 换页
    handleCurrentChange2(e) {
      this.storeList2 = []
      this.currentPage2 = e
      this.getStoreList2()
    },
    handleSelectionChange(arr) {
      const items = arr.map(item => item)
      this.selectedRows = items
      console.log("🚀 ~ handleSelectionChange ~   this.selectedRows:", this.selectedRows)
    },
    onCancel() {
      this.storeName = ""
      this.storeList2 = []
      this.dialogVisible = false
    },
    onConfirm() {
      if (this.sign == "新增") {
        this.storeList1 = this.selectedRows.concat(this.storeList1)
        this.dialogVisible = false
      } else {
        let storeIds = this.selectedRows.map(item => item.storeId)
        console.log("🚀 ~ onConfirm ~ storeIds:", storeIds)
        this.$axios
          .post(this.$api.couponaddStore, {
            couponId: this.id,
            storeIds,
          })
          .then(res => {
            this.dialogVisible = false
            this.selectedRows = []
            this.storeList2 = []
            this.getStoreList1()
            this.getStoreList2()
          })
          .catch(err => {
            this.$message.error(err.desc)
          })
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (this.storeList1.length == 0) {
          this.$message.error("请选择门店")
          return
        }
        if (valid) {
          let params = Object.assign({}, this.ruleForm)
          let api = ""
          if (this.sign == "新增") {
            api = this.$api.couponSave
            params.storeIds = this.storeList1.map(item => item.storeId)
          } else {
            api = this.$api.couponUpdate
            params.id = this.id
          }
          this.$axios
            .post(api, params)
            .then(res => {
              this.$message.success(`${this.sign}成功`)
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            })
            .catch(err => {
              this.$message.error(err.desc)
            })
        } else {
          this.$message.error("提交失败")
          return false
        }
      })
    },
    resetForm(formName) {
      this.ruleForm = createInitRuleForm()
      this.$refs[formName].resetFields()
    },
    reductionAmountChange() {},
  },
}
</script>

<style scoped lang="scss">
.details {
  .con {
    padding: 20px;

    h4 {
      margin-top: 20px;
    }

    .ruleForm {
      margin-top: 30px;

      ::v-deep .el-form-item__label {
        padding-right: 30px;
      }

      .el-select,
      .el-input {
        width: 300px;
      }

      ::v-deep input[disabled] {
        color: #272727;
        border: 1px solid #e5e7e6;
        background-color: #fff;
        cursor: default;
      }
    }

    .table_wrap {
      display: flex;
      justify-content: space-between;
    }

    .g_table {
      margin-top: 20px;
    }

    .btn {
      margin-top: 100px;
      text-align: center;

      .el-button {
        width: 120px;
      }
    }
  }
}
</style>
